import { HttpMethods, RequestPerformer } from '@/api/api-requests-factory';
import { Ref } from 'vue';
import { GetPayoutOrderListRequest } from '@/api/payout-order/get-payout-order-list.request';

export class PayoutOrderApiResources {
  constructor(
    private readonly requestPerformer: RequestPerformer,
    private readonly multibrandApiHost: Ref<string>,
  ) {}

  public get getPayoutOrderListRequest(): GetPayoutOrderListRequest {
    return new GetPayoutOrderListRequest(
      this.requestPerformer,
      `${this.multibrandApiHost.value}/api/v1.0/front/proxy`,
      HttpMethods.GET,
    );
  }
}
